import { useQuery, useManualQuery } from 'graphql-hooks';

const bidOnProductQuery = `
mutation BidOnProduct ($productId: String!, $catalogProductId: String!, $minPrice: Float!, $maxPrice: Float!, $currency: String!, $active: Boolean!, $maximizeEarningMargin: Boolean) {
    bidOnProduct(productId: $productId, catalogProductId: $catalogProductId, minPrice: $minPrice, maxPrice: $maxPrice, currency: $currency, active: $active, maximizeEarningMargin: $maximizeEarningMargin) {
        productId
        catalogProductId
        minPrice
        maxPrice
        currency
        active
        maximizeEarningMargin
    }
}`;

export const useBidOnProduct = (productId, catalogProductId, minPrice, maxPrice, currency, active, maximizeEarningMargin) => {
    const { data, loading, error } = useQuery(bidOnProductQuery, {
        variables: { productId, catalogProductId, minPrice, maxPrice, currency, active, maximizeEarningMargin }
    });

    return { data, loading, error };
}

export const useBidOnProductManual = () => {
    const [bidOnProduct, { data, loading, error }] = useManualQuery(bidOnProductQuery);
    return { bidOnProduct, data, loading, error };
}